import { DEFAULT_FLUSH_AT, DEFAULT_FLUSH_INTERVAL, DEFAULT_MAX_RETRIES, MAX_FLUSH_AT } from './constants'
import type { AnalyticsConfig, QueuedEvent } from './types'

export interface ResolvedConfig {
  endpoint: string
  apiKey: string | undefined
  flushAt: number
  flushInterval: number
  maxRetries: number
  debug: boolean
  disabled: boolean
  beforeSend: AnalyticsConfig['beforeSend']
  onError?: (error: Error, events: QueuedEvent[]) => void
}

export function resolveConfig(input: AnalyticsConfig): ResolvedConfig {
  if (!input.endpoint || input.endpoint.trim() === '') {
    throw new Error('endpoint is required')
  }

  return {
    endpoint: input.endpoint.replace(/\/$/, ''),
    apiKey: input.apiKey,
    flushAt: Math.min(input.flushAt ?? DEFAULT_FLUSH_AT, MAX_FLUSH_AT),
    flushInterval: input.flushInterval ?? DEFAULT_FLUSH_INTERVAL,
    maxRetries: input.maxRetries ?? DEFAULT_MAX_RETRIES,
    debug: input.debug ?? false,
    disabled: input.disabled ?? false,
    beforeSend: input.beforeSend,
    onError: input.onError,
  }
}
